export default __webpack_public_path__ + "static/media/gwn40.7f234cf7.webp";